import api from '../services/api'

export const usersGetToken = (data) => {
    return api.post('/users/token', data);
}